import { render, staticRenderFns } from "./ServiciosHigienePagination.vue?vue&type=template&id=42ec0eaf&"
import script from "./ServiciosHigienePagination.vue?vue&type=script&lang=js&"
export * from "./ServiciosHigienePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports